/*
The only effect this seems to have is silence an annoying Mobx warning in dev:
"[MobX] Failed to get unstable_batched updates from react-dom / react-native"
I believe that unstable_batchedUpdates is not available in the Next Edge runtime, causing the above warning.
This is safe because this replicates how React now handles unstable_batchedUpdates since React 18:
https://github.com/facebook/react/blob/v19.1.0/packages/react-dom/src/shared/ReactDOM.js#L51
*/

export function unstable_batchedUpdates(fn, args) {
  fn(args);
}
